import $ from "jquery";

export function setupFilmroom() {
  $(".btn_filmroom").on("click", selectType);
  $(".filmroom_list_ball").on("click", selectListItem);
  $("#btn_search").on("click", search);
  $(".btn_video_pos").on("click", selectPos);

  $(window).resize(function () {
    var isPC = $(window).width() > 960;
    if (isPC) {
      $(".filmroom_menu").show();
      $(".filmroom_video").show();
      $(".filmroom_videolist").show();
      $(".filmroom").show();
    }
  });

  setHeight();
  checkBottomFixed();
  $(window).on("scroll", function () {
    checkBottomFixed();
  });
}

function setHeight() {
  let height1 = parseInt($(".filmroom_menu").outerHeight());
  let padding_top = parseInt($(".filmroom_menu").css("padding-top"));
  let height2 = $(".filmroom_videolist").height();
  let max_height = Math.max(height1, height2);

  $(".filmroom_menu").css("height", max_height + "px");
  $(".filmroom_videolist").css("height", max_height - padding_top + "px");
}

function checkBottomFixed() {
  var isPC = $(window).width() > 960;
  if (!isPC) return;
  setHeight();
  if (
    $(window).scrollTop() >=
      $(".filmroom_menu").offset().top +
        $(".filmroom_menu").outerHeight() -
        window.innerHeight &&
    $(".filmroom_menu_bottom").css("position") === "fixed"
  ) {
    $(".filmroom_menu_bottom").css("position", "absolute");
    $(".filmroom_videoctl").css("position", "absolute");
  } else if (
    $(window).scrollTop() <
      $(".filmroom_menu").offset().top +
        $(".filmroom_menu").outerHeight() -
        window.innerHeight &&
    $(".filmroom_menu_bottom").css("position") === "absolute"
  ) {
    $(".filmroom_menu_bottom").css("position", "fixed");
    $(".filmroom_videoctl").css("position", "fixed");
  }
}

function selectType() {
  $(".btn_filmroom").removeClass("btn_blue_filmroom2");
  $(".btn_filmroom").removeClass("btn_white_filmroom2");
  $(".btn_filmroom").addClass("btn_white_filmroom2");
  $(this).addClass("btn_blue_filmroom2");
}

function selectListItem() {
  var ball = $(this).attr("ball");
  var isPC = $(window).width() > 960;
  if (!isPC) {
    $(".filmroom_video").show();
    $(".filmroom_videolist").hide();
  }

  $(".btn_video_pos").removeClass("btn_filmroom_list");
  $(".btn_video_pos").removeClass("btn_filmroom_listr");
  $(".btn_video_pos[pos=1]").addClass("btn_filmroom_list");
  $(".btn_video_pos[pos!=1]").addClass("btn_filmroom_listr");
}

function selectPos() {
  if ($(this).hasClass("btn_filmroom_list")) {
    $(this).removeClass("btn_filmroom_list");
    $(this).addClass("btn_filmroom_listr");
  } else {
    $(this).removeClass("btn_filmroom_listr");
    $(this).addClass("btn_filmroom_list");
  }
}

function search() {
  var isPC = $(window).width() > 960;

  if (!isPC) {
    $(".filmroom_menu").hide();

    $(".filmroom_video").hide();
    $(".filmroom_videolist").show();
    $(".filmroom").show();
  }
}
// function search() {
//   const query = $("#search_input").val().toLowerCase();
//   const results = videos.filter(video => {
//       return (
//           video.year.includes(query) ||
//           video.date.includes(query) ||
//           video.team1.toLowerCase().includes(query) ||
//           video.team2.toLowerCase().includes(query) ||
//           video.hitter.toLowerCase().includes(query) ||
//           video.pitcher.toLowerCase().includes(query) ||
//           video.Umpire.toLowerCase().includes(query)
//       );
//   });

//   displayResults(results);
// }

// function displayResults(results) {
//   const resultsDiv = $("#search_results");
//   resultsDiv.empty();

//   if (results.length === 0) {
//       resultsDiv.append("<p>沒有找到相關結果</p>");
//       return;
//   }

//   results.forEach(video => {
//       resultsDiv.append(
//           `<div>
//               <p>${video.year} - ${video.date}</p>
//               <p>${video.team1} vs ${video.team2}</p>
//               <p>${video.details}</p>
//               <p>打者: ${video.hitter}</p>
//               <p>投手: ${video.pitcher}</p>
//               <p>裁判: ${video.Umpire}</p>
//           </div>`
//       );
//   });
// }
